"use client"

import styled from "@emotion/styled"
import { Button, Typography } from "@mui/material"
import Image from "next/image"

const ResultContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  padding: 32px;
  width: 100%;
  height: 667px;
  border: 1px solid #aaaaaa;
  border-radius: 8px;
  background-color: white;
`

const ImageContainer = styled.div`
  width: 130px;
  height: 131px;
  display: flex;
  align-items: center;
  justify-content: center;
`

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: 100%;
`

const StyledButton = styled(Button)`
  ${(props) => props.theme.breakpoints.up("md")} {
    max-width: 249px;
  }
`

interface ResultProps {
  type: "success" | "error"
  onRetry?: () => void
}

export default function Result({ type, onRetry }: ResultProps) {
  const isSuccess = type === "success"

  return (
    <ResultContainer>
      <ImageContainer>
        <Image
          src={isSuccess ? "/images/success.gif" : "/images/error.gif"}
          alt={isSuccess ? "Success" : "Error"}
          width={130}
          height={131}
        />
      </ImageContainer>

      <ContentContainer role="alert">
        <Typography variant="h2">
          {isSuccess ? "פרטיך נקלטו בהצלחה" : "משהו השתבש בדרך"}
        </Typography>

        <Typography variant="body2">
          {isSuccess
            ? "נציגנו יצור עימך קשר בהקדם"
            : "נראה שמשהו השתבש והפרטים שלך לא נשלחו, אנא נסה שנית."}
        </Typography>
      </ContentContainer>

      {!isSuccess && onRetry && (
        <StyledButton
          fullWidth
          size="large"
          variant="primary"
          onClick={onRetry}
        >
          נסה שנית
        </StyledButton>
      )}
    </ResultContainer>
  )
}
